
import { common as enCommon } from './en/common';
import { common as arCommon } from './ar/common';

export const resources = {
  en: {
    common: enCommon,
  },
  ar: {
    common: arCommon,
  },
};
